import React, { useState } from 'react';
import './Gallery.css';
import { FaSearch, FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import Door1 from '../Assets/Door-1.jpg';
import Door2 from '../Assets/Door-2.jpg';
import Door3 from '../Assets/Door-3.jpg';
import Door4 from '../Assets/Door-4.jpeg';
import Door5 from '../Assets/Door-5.jpg';
import Floor1 from '../Assets/Floor-1.jpg';
import Floor2 from '../Assets/Floor-2.jpg';
import Floor3 from '../Assets/Floor-3.webp';
import Floor4 from '../Assets/Floor-4.jpg';
import Kitchen1 from '../Assets/Kitchen-1.webp';
import Kitchen2 from '../Assets/Kitchen-2.jpg';
import Kitchen3 from '../Assets/Kitchen-3.jpg';
import Kitchen4 from '../Assets/Kitchen-4.jpg';
import Kitchen5 from '../Assets/Kitchen-5.jpeg';
import Kitchen6 from '../Assets/Project-Modern-Kitchen.jpg';
import Roof1 from '../Assets/Roof-1.jpg';
import Roof2 from '../Assets/Roof-2.jpg';
import Roof3 from '../Assets/Roof-3.jpg';
import Roof4 from '../Assets/Roof-4.jpg';
import Wood1 from '../Assets/Wood-1.jpg';
import Wood2 from '../Assets/Wood-2.jpg';
import Wood3 from '../Assets/Wood-3.png';
import Wood4 from '../Assets/Wood-4.jpg';
import Wood5 from '../Assets/Wood-5.jpg';
import Media1 from '../Assets/Media-wall-1.jpeg';
import Media2 from '../Assets/Media-wall-2.jpeg';
import Media3 from '../Assets/Media-wall-3.jpeg';
import Media4 from '../Assets/Media-wall-4.jpeg';
import Media5 from '../Assets/Media-wall-5.jpeg';

const Gallery = () => {
  // Sample gallery data - replace with your actual images
  const galleryData = [
    {
      id: 1,
      category: 'Wood & Timber Work',
      title: 'Custom Frame Work',
      image: Wood5,
    },
    {
      id: 2,
      category: 'Wood & Timber Work',
      title: 'Teak Deck Construction',
      image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf',
    },
    {
      id: 3,
      category: 'Roof Conversions & Extensions',
      title: 'Loft Conversion',
      image: Roof4,
    },
    {
      id: 4,
      category: 'Roof Conversions & Extensions',
      title: 'Thatched Roof Extension',
      image: 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154',
    },
    {
      id: 5,
      category: 'Wood Flooring & Cabinets',
      title: 'Custom Cabinets',
      image: Floor4,
    },
    {
      id: 6,
      category: 'Wood Flooring & Cabinets',
      title: 'Custom Kitchen Cabinets',
      image: 'https://images.unsplash.com/photo-1600121848594-d8644e57abab',
    },
    {
      id: 7,
      category: 'Doors & Windows',
      title: 'Double Glazed Windows',
      image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d',
    },
    {
      id: 8,
      category: 'Doors & Windows',
      title: 'French Doors Installation',
      image: 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154',
    },
    {
      id: 9,
      category: 'Professional Kitchen Installation',
      title: 'Modern Chef Kitchen',
      image: Kitchen6,
    },
    {
      id: 10,
      category: 'Professional Kitchen Installation',
      title: 'Rustic Kitchen Remodel',
      image: 'https://images.unsplash.com/photo-1600121848594-d8644e57abab',
    },
    {
      id: 11,
      category: 'Doors & Windows',
      title: 'Double Glazed Windows',
      image: Door1,
    },
    {
      id: 12,
      category: 'Wood & Timber Work',
      title: 'Custom Frame Work',
      image: Wood3,
    },
    {
      id: 13,
      category: 'Roof Conversions & Extensions',
      title: 'Loft Conversion',
      image: Roof3,
    },
    {
      id: 14,
      category: 'Professional Kitchen Installation',
      title: 'Modern Chef Kitchen',
      image: Kitchen5,
    },
    {
      id: 15,
      category: 'Wood Flooring & Cabinets',
      title: 'Custom Cabinets',
      image: Floor3,
    },
    {
      id: 16,
      category: 'Wood & Timber Work',
      title: 'Custom Frame Work',
      image: Wood2,
    },
    {
      id: 17,
      category: 'Roof Conversions & Extensions',
      title: 'Loft Conversion',
      image: Roof2,
    },
    {
      id: 18,
      category: 'Professional Kitchen Installation',
      title: 'Modern Chef Kitchen',
      image: Kitchen4,
    },
    {
      id: 19,
      category: 'Wood Flooring & Cabinets',
      title: 'Custom Cabinets',
      image: Floor2,
    },
    {
      id: 20,
      category: 'Doors & Windows',
      title: 'Double Glazed Windows',
      image: Door2,
    },
    {
      id: 21,
      category: 'Wood & Timber Work',
      title: 'Custom Frame Work',
      image: Wood4,
    },
    {
      id: 22,
      category: 'Professional Kitchen Installation',
      title: 'Modern Chef Kitchen',
      image: Kitchen3,
    },
    {
      id: 23,
      category: 'Wood Flooring & Cabinets',
      title: 'Custom Cabinets',
      image: Floor1,
    },
    {
      id: 24,
      category: 'Doors & Windows',
      title: 'Double Glazed Windows',
      image: Door3,
    },
    {
      id: 25,
      category: 'Wood & Timber Work',
      title: 'Custom Frame Work',
      image: Wood1,
    },
    {
      id: 26,
      category: 'Professional Kitchen Installation',
      title: 'Modern Chef Kitchen',
      image: Kitchen2,
    },
    {
      id: 27,
      category: 'Doors & Windows',
      title: 'Double Glazed Windows',
      image: Door4,
    },
    {
      id: 28,
      category: 'Roof Conversions & Extensions',
      title: 'Loft Conversion',
      image: Roof1,
    },
    {
      id: 29,
      category: 'Doors & Windows',
      title: 'Double Glazed Windows',
      image: Door5,
    },
    {
      id: 30,
      category: 'Professional Kitchen Installation',
      title: 'Modern Chef Kitchen',
      image: Kitchen1,
    },
    {
      id: 31,
      category: 'Wood & Timber Work',
      title: 'Luxury Media Wall',
      image: Media1,
    },
    {
      id: 32,
      category: 'Wood & Timber Work',
      title: 'Custom Media Wall',
      image: Media2,
    },
    {
      id: 33,
      category: 'Wood & Timber Work',
      title: 'Contemporary Media Wall',
      image: Media3,
    },
    {
      id: 34,
      category: 'Wood & Timber Work',
      title: 'Sleek Media Wall',
      image: Media4,
    },
    {
      id: 35,
      category: 'Wood & Timber Work',
      title: 'Floating Media Wall',
      image: Media5,
    },

    
    // Add more images as needed
  ];

  const categories = [
    'All Projects',
    'Wood & Timber Work',
    'Roof Conversions & Extensions',
    'Wood Flooring & Cabinets',
    'Doors & Windows',
    'Professional Kitchen Installation'
  ];

  const [activeCategory, setActiveCategory] = useState('All Projects');
  const [searchTerm, setSearchTerm] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  const filteredProjects = galleryData.filter(project => {
    const matchesCategory = activeCategory === 'All Projects' || project.category === activeCategory;
    const matchesSearch = project.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                         project.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const openLightbox = (index) => {
    setCurrentImage(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const navigateLightbox = (direction) => {
    if (direction === 'prev') {
      setCurrentImage(prev => (prev === 0 ? filteredProjects.length - 1 : prev - 1));
    } else {
      setCurrentImage(prev => (prev === filteredProjects.length - 1 ? 0 : prev + 1));
    }
  };

  return (
    <div className="gallery-page">
      {/* Hero Section */}
      <section className="gallery-hero">
        <div className="hero-content">
          <h1>Our Project Gallery</h1>
          <p>Showcasing our craftsmanship across all construction specialties</p>
        </div>
      </section>

      {/* Gallery Controls */}
      <section className="gallery-controls">
        <div className="container">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search projects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          
          <div className="category-filter">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-grid">
        <div className="container">
          {filteredProjects.length > 0 ? (
            <div className="grid-container">
              {filteredProjects.map((project, index) => (
                <div 
                  key={project.id} 
                  className="gallery-item"
                  onClick={() => openLightbox(index)}
                >
                  <div 
                    className="item-image"
                    style={{ backgroundImage: `url(${project.image})` }}
                  >
                    <div className="image-overlay">
                      <span className="category-badge">{project.category}</span>
                    </div>
                  </div>
                  <div className="item-info">
                    <h3>{project.title}</h3>
                    {/* <p>{project.description}</p> */}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <h3>No projects found matching your criteria</h3>
              <button 
                className="reset-btn"
                onClick={() => {
                  setActiveCategory('All Projects');
                  setSearchTerm('');
                }}
              >
                Reset Filters
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="lightbox">
          <div className="lightbox-content">
            <button className="close-btn" onClick={closeLightbox}>×</button>
            <div className="lightbox-image-container">
              <img 
                src={filteredProjects[currentImage].image} 
                alt={filteredProjects[currentImage].title}
                className="lightbox-image"
              />
              <button 
                className="nav-btn prev-btn"
                onClick={() => navigateLightbox('prev')}
              >
                <FaArrowLeft />
              </button>
              <button 
                className="nav-btn next-btn"
                onClick={() => navigateLightbox('next')}
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="gallery-cta">
        <div className="container">
          <h2>Ready to Start Your Project?</h2>
          <p>Viewing our gallery is just the beginning. Let's discuss how we can bring your vision to life.</p>
          <div className="cta-buttons">
            <button className="primary-btn">Get a Free Quote</button>
            <button className="secondary-btn">Call Now: +44 7405 395507</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;